import { Box, CircularProgress, Typography } from "@mui/material";
import { useQuery } from "react-query";
import { PostOrderAPI } from "../../../../../utils/api/requests/postOrder-requests";
import { useTranslation } from "react-i18next";
// import { ProgressBar } from "../../../../../ui/atoms/ProgressBar";

export const Overview = () => {
  const { t } = useTranslation();
  const { data } = useQuery({
    queryFn: PostOrderAPI.getOverview,
    onError: () => {},
    queryKey: "overview",
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    refetchInterval: 10000,
  });

  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "100%", md: "240px" },
        height: "120px",
        boxShadow:
          "rgba(0, 0, 0, 0.04) 0px 5px 22px, rgba(0, 0, 0, 0.03) 0px 0px 0px 0.5px",
        borderRadius: "16px",
        padding: "12px",
        mb: "24px",
        color: "rgb(108, 115, 127)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        mr: "24px",
      }}
    >
      <Typography
        sx={{ fontSize: "1rem", color: "rgb(17, 25, 39)", mb: "12px" }}
      >
        {t("overview.overview")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          flex: 1,
        }}
      >
        {!data ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: "12px",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {t("post")}: {data?.post_orders}
            </Typography>
            <Typography sx={{ fontSize: "0.875rem", mb: "36px" }}>
              {t("overview.channel")}: {data?.channel_orders}
            </Typography>
            {/* <ProgressBar progress={data?.loading || 0} /> */}
          </>
        )}
      </Box>
    </Box>
  );
};
